document.addEventListener('DOMContentLoaded', function () {
    var availableInChineseBanner = document.querySelector('.available-in-chinese-msg');
    if (availableInChineseBanner !== null && availableInChineseBanner.length > 0) {
        if (document.querySelector('.CybotCookiebotDialogActive') !== null) {
            window.addEventListener('CookiebotOnAccept', function (e) {
                availableInChineseBanner.classList.add('show');
            }, false);
            window.addEventListener('CookiebotOnDecline', function (e) {
                availableInChineseBanner.classList.add('show');
            }, false);
        } else {
            setTimeout(function () {
                availableInChineseBanner.classList.add('show');
            }, 2000);
        }
    }
});